import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";


interface CicloState {
    status: string;
    error: string;
    cicloList: any[],
    cicloListActive: any[],
    ciclo: {
        idCiclo: number | null;
        idDiplomado: number | null;
        nombre: string | null;
        descripcion: string | null;
        estado: number | null;
    }

}

const initialState: CicloState = {
    status: 'idle',
    error: '',
    cicloList: [],
    cicloListActive: [],
    ciclo: {
        idCiclo: null,
        idDiplomado: null,
        nombre: null,
        descripcion: null,
        estado: null
    }
}

export const fetchCiclo = createAsyncThunk('fetchCiclo', async ({ idDiplomado }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 64;
    const { result, message, data } = await getData({ idsp, idDiplomado }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchFacilitadorCiclo = createAsyncThunk('fetchFacilitadorCiclo', async (_: any, { dispatch, getState, rejectWithValue }) => {

    const idsp = 119;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchAlumnoCiclo = createAsyncThunk('fetchAlumnoCiclo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 202;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateCiclo = createAsyncThunk('modifyCreateCiclo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const cicloNew = selectCiclo(state);
    const cicloAttributes = {
        idCiclo: cicloNew.idCiclo,
        idDiplomado: cicloNew.idDiplomado,
        nombre: cicloNew.nombre,
        descripcion: cicloNew.descripcion
    };
    const idDiplomado = cicloAttributes.idDiplomado;
    const idsp = cicloAttributes.idCiclo ? 62 : 61;
    let alert: AlertInterface;

    const { result, message, data } = await getData({idsp, ...cicloAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchCiclo({ idDiplomado }));
    return rejectWithValue(message);
});

export const updateEstadoCiclo = createAsyncThunk('updateEstadoCiclo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const cicloNew = selectCiclo(state);
    const cicloAttributes = { ...cicloNew }
    const estado = !cicloAttributes.estado;
    const idCiclo = cicloAttributes.idCiclo;
    const idDiplomado = cicloAttributes.idDiplomado;
    const idsp = 63;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idCiclo }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchCiclo({ idDiplomado }));
    return rejectWithValue(message);
});


export const cicloSlice = createSlice({
    name: 'ciclo',
    initialState,
    reducers: {
        setCicloList: (state, action) => {
            state.cicloList = action.payload;
        },
        setCicloListActive: (state, action) => {
            state.cicloListActive = action.payload;
        },
        setCiclo: (state, action) => {
            state.ciclo = !action.payload ? initialState.ciclo : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCiclo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCiclo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.cicloList = data ? data : [];

            })
            .addCase(fetchCiclo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchFacilitadorCiclo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFacilitadorCiclo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.cicloList = data ? data : [];

            })
            .addCase(fetchFacilitadorCiclo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchAlumnoCiclo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAlumnoCiclo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.cicloList = data ? data : [];
            })
            .addCase(fetchAlumnoCiclo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })

    }
})

export const selectCicloList = (state: RootState) => state.ciclo.cicloList;
export const selectCicloListActive = (state: RootState) => state.ciclo.cicloListActive;
export const selectCiclo = (state: RootState) => state.ciclo.ciclo;
export const selectCicloStatus = (state: RootState) => state.ciclo.status;

export const { setCicloList, setCicloListActive, setCiclo } = cicloSlice.actions;

export default cicloSlice.reducer;
